import { ChatroomInputFormSkeleton } from '../ChatroomInputForm'
import { ChatroomMessagesSkeleton } from '../ChatroomMessagesSkeleton'

import * as styles from './ChatroomSkeleton.module.css'

function ChatroomSkeleton({ className = styles.ChatroomSkeleton }) {
  return (
    <div className={className}>
      <div className={styles.contentArea}>
        <ChatroomMessagesSkeleton />
      </div>
      <ChatroomInputFormSkeleton />
    </div>
  )
}

export default ChatroomSkeleton
